import "./DappService.css";
import Button from "../button/Button";
import { Link, useNavigate } from "react-router-dom";
const DappService = () => {

  return (
    <div id="service-progressive" className="progressive-wrapper">
       <div className="Container-main">
        <div className="serviceContent">
          
           <h2>Launch a Secure, Scalable dApp Built for Long-Term Growth</h2>
          <p>
         Build a scalable dApp with enterprise-ready blockchain architecture—book a consultation to begin.
</p>
          <div><Link to='/contact_us' className="link"><Button  arrowColor="purple" text="Contact Us Now!"/></Link></div>
        </div>
     </div>
    </div>
  );
};

export default DappService;
